// 빈 모듈 - 백엔드 전용 패키지 경로를 매핑하기 위한 더미 모듈
// 모든 named export를 빈 함수나 객체로 제공

// reflect-metadata polyfill
if (typeof Reflect !== "undefined" && !(Reflect as any).getMetadata) {
  (Reflect as any).getMetadata = () => undefined;
  (Reflect as any).defineMetadata = () => {};
  (Reflect as any).hasMetadata = () => false;
  (Reflect as any).getOwnMetadata = () => undefined;
  (Reflect as any).defineOwnMetadata = () => {};
  (Reflect as any).hasOwnMetadata = () => false;
  (Reflect as any).getMetadataKeys = () => [];
  (Reflect as any).getOwnMetadataKeys = () => [];
  (Reflect as any).deleteMetadata = () => false;
  (Reflect as any).metadata = () => () => {};
}

// @nestjs/swagger exports
export const ApiProperty = () => () => {};
export const ApiPropertyOptional = () => () => {};
export const ApiResponse = () => () => {};
export const ApiTags = () => () => {};
export const ApiOperation = () => () => {};
export const ApiParam = () => () => {};
export const ApiQuery = () => () => {};
export const ApiBody = () => () => {};
export const ApiBearerAuth = () => () => {};
export const ApiHeader = () => () => {};
export const ApiExcludeEndpoint = () => () => {};
export const ApiExcludeController = () => () => {};
export const ApiOkResponse = () => () => {};
export const ApiCreatedResponse = () => () => {};
export const ApiBadRequestResponse = () => () => {};
export const ApiUnauthorizedResponse = () => () => {};
export const ApiForbiddenResponse = () => () => {};
export const ApiNotFoundResponse = () => () => {};
export const ApiInternalServerErrorResponse = () => () => {};

// @nestjs/common exports
export const Injectable = () => () => {};
export const Controller = () => () => {};
export const Get = () => () => {};
export const Post = () => () => {};
export const Put = () => () => {};
export const Patch = () => () => {};
export const Delete = () => () => {};
export const Body = () => () => {};
export const Param = () => () => {};
export const Query = () => () => {};
export const Headers = () => () => {};
export const Req = () => () => {};
export const Res = () => () => {};
export const HttpCode = () => () => {};
export const HttpStatus = {};
export const Logger = class {};
export const ConsoleLogger = class {};

// @nestjs/mapped-types exports
export const PartialType = () => class {};
export const PickType = () => class {};
export const OmitType = () => class {};
export const IntersectionType = () => class {};

// class-transformer/storage exports
export const defaultMetadataStorage = {};

// 기본 export
export default {};

